<bz-loading *ngIf="showLoading">
</bz-loading>

<div class="select-category" *ngIf="!showLoading">
    <div class="select-category__select">
        <span class="select-category__select-label">{{ 'BASEKNOWLEDGECATALOG.CATEGORY' | translate }}</span>
        <bzg-select placeholder="Select category" [(value)]="selectedCategory" (valueChange)="onCategoryChange($event)" [compareWith]="compareCategory">
            <bzg-option [value]="allCategory">{{ 'BASEKNOWLEDGECATALOG.ALL' | translate }}</bzg-option>
            <bzg-option *ngFor="let category of currentCategoryList" [value]="category">
                {{ category.DisplayName }}</bzg-option>
        </bzg-select>
    </div>
    <bzg-search class="select-category__search" [placeholder]="'BASEKNOWLEDGECATALOG.SEARCH' | translate" (valueChange)="onSearch($event)" [fieldText]="inputSearch" (keydown.enter)="onEnterSearch()" (paste)="onPaste($event)"></bzg-search>
</div>

<div *ngIf="!showLoading" class="custom-tabs">
    <div class="tab-header">
        <div *ngIf="showFiles" class="tab-button" [class.active]="getTabIndex('files') === selectedTab" (click)="selectTab(getTabIndex('files'))">
            <bzg-icon [nameIcon]="'icon-knowledge-static'" [size]="16" class="tab-icon"></bzg-icon>
            <span>{{ 'BASEKNOWLEDGECATALOG.STATIC' | translate | uppercase }}</span>
        </div>
        <div *ngIf="showLearned && !showNewBizagiDataView" class="tab-button" [class.active]="getTabIndex('learned') === selectedTab" (click)="selectTab(getTabIndex('learned'))">
            <bzg-icon [nameIcon]="'icon-knowledge-learned'" [size]="16" class="tab-icon"></bzg-icon>
            <span>{{ 'BASEKNOWLEDGECATALOG.BIZAGI_DATA' | translate | uppercase }}</span>
        </div>
        <div *ngIf="showLearned && showNewBizagiDataView" class="tab-button" [class.active]="getTabIndex('bizagiData') === selectedTab" (click)="selectTab(getTabIndex('bizagiData'))">
            <bzg-icon [nameIcon]="'icon-bizagi-data-22'" [size]="16" class="tab-icon"></bzg-icon>
            <span>{{ 'BASEKNOWLEDGECATALOG.BIZAGI_DATA' | translate | uppercase }}</span>
        </div>
    </div>

    <div class="tab-content">
        <div *ngIf="getTabIndex('files') === selectedTab && showFiles" class="tab-panel">
            <bz-loading *ngIf="isLoadingFiles" [size]="'xl'"></bz-loading>
            <biz-base-knowledge-catalog-static *ngIf="!isLoadingFiles" 
                [selectedCategory]="selectedCategory" 
                [filteredCategoryList]="filteredCategoryList" 
                (reloadCatalogs)="reloadCatalogs($event)">
            </biz-base-knowledge-catalog-static>
        </div>
        <div *ngIf="getTabIndex('learned') === selectedTab && showLearned && !showNewBizagiDataView" class="tab-panel">
            <bz-loading *ngIf="isLoadingLearned" [size]="'xl'"></bz-loading>
            <biz-base-knowledge-catalog-learned *ngIf="!isLoadingLearned"
                [selectedCategory]="selectedCategory" 
                [filteredCategoryListLearned]="filteredCategoryListLearned" 
                (refreshKBLearnedOutput)="refreshKBLearned($event)">
            </biz-base-knowledge-catalog-learned>
        </div>
        <div *ngIf="getTabIndex('bizagiData') === selectedTab && showLearned && showNewBizagiDataView" class="tab-panel">
            <bz-loading *ngIf="isLoadingLearned" [size]="'xl'"></bz-loading>
            <biz-base-knowledge-catalog-bizagi-data *ngIf="!isLoadingLearned"
                [filteredCategoryListBizagiData]="filteredCategoryListLearned" 
                (refreshBizagiDataOutput)="refreshKBLearned($event)">
            </biz-base-knowledge-catalog-bizagi-data>
        </div>
    </div>
</div>